/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  /* Fix input doesn't focus in Brooklyn theme */
  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
    jQ('.mfp-close').trigger('click');
  }

  
  /* #160502 */
  InstantSearchApi.beforeCall = function(searchTerm) {
      /* Change the params before calling api */
      var selected_collection = localStorage.getItem("boostSearchCollection");
      Globals.instantSearchQueryParams.collection_scope = selected_collection;
      Globals.instantSearchQueryParams.check_cache = false;
  }
  
  SearchInput.prototype._bindAutoCompleteSource = function(request, response) {
      window.suggestionCallback = response;
      Globals.currentTerm = Utils.stripHtml(request.term);
      var term = (request.term).trim().replace(/\s+/g, ' ');
      if (term != '') {
          var $instantSearchResult = this.searchAutoComplete.$element;
          this.instantSearchResult.setData($instantSearchResult, null, true);
          this.instantSearchResult.refresh();
          //if (Globals.suggestionCache.hasOwnProperty(term)) {
          //	window.suggestionCallback(Globals.suggestionCache[term]);
              //return;
          //}
          term = encodeURIComponent(term);
          InstantSearchApi.getSuggestionData(term, 0, 'suggest');
      }
  };

  if(typeof(localStorage.getItem("boostSearchCollection")) == 'undefined' || localStorage.getItem("boostSearchCollection") == null){
      var defaultCollectionVal = jQ('.bc-select-collection').val();
      localStorage.setItem("boostSearchCollection", defaultCollectionVal);
  }
  
  if(localStorage.getItem("boostSearchCollection") !== null){
      jQ("select.bc-select-collection option").removeAttr('selected');
      jQ("select.bc-select-collection [value='" + localStorage.getItem("boostSearchCollection") + "']").attr('selected','selected');
      jQ('.bc-sf-input-collection').val(localStorage.getItem("boostSearchCollection"));
  }
  
  jQ("select.bc-select-collection").on('change',function(){
      var selected = jQ(this).val();
      jQ("select.bc-select-collection option").removeAttr('selected');
      jQ("select.bc-select-collection [value='" + selected + "']").attr('selected','selected');
      localStorage.setItem("boostSearchCollection", selected);
      jQ('.bc-sf-input-collection').val(selected);
  });
  /* End #160502 */

})();